import { Outlet } from "react-router";
import { useCheckUpdate } from "../hooks/useCheckUpdate";
import FullLoadingScreen from "./FullLoadingScreen";

export const AppMainWrapper = () => {
	const { isChecking: isCheckingVersion } = useCheckUpdate();

	if (isCheckingVersion) return <FullLoadingScreen />;

	return <Outlet />;
};
